import React, {Component} from 'react';
import {connect} from 'react-redux';
import {modeEmail} from '../../../actions/actionsAnimalList';
import {changeEmail, changeMensaje, changeNombre, init} from '../../../../Shared/actions/actionsContactByEmail';
import Alert from 'react-s-alert';
import {showWaitBlock} from "../../../../Structure/actions/actionsStructure";

class Old_CardListingContactByEmail extends Component {


    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.hideEmail = this.hideEmail.bind(this);
    }

    hideEmail() {
        this.props.changeModeEmail(false, this.props.animalsControl);
    }

    handleChange(event) {
        if ($(event.currentTarget).hasClass("formNombre")) {
            this.props.changeNombre($(event.currentTarget).val(), this.props.animalsControl);
        } else if ($(event.currentTarget).hasClass("formEmail")) {
            this.props.changeEmail($(event.currentTarget).val(), this.props.animalsControl);
        } else if ($(event.currentTarget).hasClass("formMensaje")) {
            this.props.changeMensaje($(event.currentTarget).val(), this.props.animalsControl);
        }
    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase().trim());
    }

    sendEmail(e) {
        //console.log("Old_CardListingContactByEmail::onSendEmail()");
        //Comprobar que todos los campos son correctos.
        let errorMessage = "";
        let nombre = $('.formNombre');
        let email = $('.formEmail');
        let mensaje = $('.formMensaje');

        if (nombre.val() === "") {
            nombre.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Nombre";
            } else {
                errorMessage += ", nombre";
            }
        } else {
            nombre.removeClass('formInputError')
        }

        if (email.val() === "") {
            email.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Email";
            } else {
                errorMessage += ", email";
            }
        } else {
            if (!this.validateEmail(email.val().trim())) {
                email.removeClass('formInputError').addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email no válido";
                } else {
                    errorMessage += ", email no válido";
                }
            } else {
                email.removeClass('formInputError')
            }
        }

        if (mensaje.val() === "") {
            mensaje.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Mensaje";
            } else {
                errorMessage += ", mensaje";
            }
        } else {
            mensaje.removeClass('formInputError')
        }

        Alert.closeAll();
        if (errorMessage !== "") {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 'none',
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
        } else {
            this.props.changeWaitBlock(true)

            this.props.onSendEmail()

            e.preventDefault();
        }
    }

    render() {
        let url_imagen = "", nombre = "";
        if (this.props.source === "protectora") {
            url_imagen = this.props.infoProtectoraDetail.img_principal.url;
            nombre = this.props.infoProtectoraDetail.nombre;
        } else if (this.props.source === "animal") {
            url_imagen = this.props.infoAnimalDetail.img_principal.url;
            nombre = this.props.infoAnimalDetail.nombre;
        }
        //console.log("Old_CardListingContactByEmail::render()");
        return (
            <div className="card-block">
                <div className="cardInfoDetailShow">
                    <div className="informationDetailDescription">
                        {/*<div className="headContactEmailLeft">*/}
                        {/*    <img src={url_imagen} alt="" className="embed-responsive imagenContactEmail"/>*/}
                        {/*</div>*/}
                        <div className="headContactEmailRight">
                            <div className="form-group row">
                                {/*<label htmlFor="example-text-input-with-left-icon" className="col-3 col-form-label">Nombre: </label>*/}
                                <div className="col-9 input-form-contact-email">
                                    <div className="form-control-inline-icon inline-icon-left">
                                        <div className="contentIconContactEmail">
                                            <span className="iconContactEmail las la-lg la-user"></span>
                                        </div>
                                        <input id="example-text-input-with-left-icon" type="text"
                                               value={this.props.optionsEmail.nombre} onChange={this.handleChange}
                                               className="form-control form-control-2 formNombre"
                                               placeholder="Tu nombre"/>
                                    </div>
                                </div>

                            </div>
                            <div className="form-group row">
                                {/*<label htmlFor="example-text-input-with-left-icon" className="col-3 col-form-label">Email: </label>*/}
                                <div className="col-9 input-form-contact-email">
                                    <div className="form-control-inline-icon inline-icon-left">
                                        <div className="contentIconContactEmail">
                                            <span className="iconContactEmail las la-lg la-at"></span>
                                        </div>
                                        <input id="example-text-input-with-left-icon" type="text"
                                               value={this.props.optionsEmail.email} onChange={this.handleChange}
                                               className="form-control form-control-2 formEmail" placeholder="Email"/>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="form-group row">*/}
                            {/*    <label htmlFor="example-text-input-with-left-icon" className="col-3 col-form-label">Asunto: </label>*/}
                            {/*    <div className="col-9">*/}
                            {/*        <div className="form-control-inline-icon inline-icon-left">*/}
                            {/*            <div className="contentIconContactEmail">*/}
                            {/*                <span className="iconContactEmail las la-lg la-folder-open"></span>*/}
                            {/*            </div>*/}
                            {/*            <input id="example-text-input-with-left-icon" type="text" value={this.props.optionsEmail.asunto} onChange={this.handleChange} className="form-control form-control-2" placeholder={this.props.optionsEmail.asunto} disabled/>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="informationDetail">
                        <div className="form-group row">
                            <div className="col-12">
                                <textarea id="mensaje_email" className="form-control formMensaje"
                                          value={this.props.optionsEmail.mensaje} onChange={this.handleChange}
                                          placeholder="Escribe tu mensaje" rows="10"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="informationDetail ">
                        <div className="form-group row botones_email">
                            <a onClick={this.hideEmail} href="#" id=""
                               className="btn btn-outline-primary listing-houses__item-view-link atras_email">Atrás</a>
                            <a onClick={this.sendEmail} href="#" id=""
                               className="btn btn-outline-primary listing-houses__item-view-link enviar_email">Enviar</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillMount() {
        this.props.init(this.props.animalsControl);
    }

    componentDidMount() {
        //$('.informationDetailDescription input').first().focus();

        var nav = $(".informationDetailDescription");

        var animateTime = 20;
        // this.autoHeightAnimate(nav, animateTime);


        const divcardContactEmail = $('.cardContactEmail');
        if (divcardContactEmail && divcardContactEmail[0] && divcardContactEmail.offset().top < ($(window).scrollTop())) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({                scrollTop: divcardContactEmail.offset().top - 100            }, 0);

        }

    }

    autoHeightAnimate(element, time) {
        //console.log("Old_CardListingContactByEmail::autoHeightAnimate()");
        var curHeight = element.height(); // Get Default Height
        var autoHeight = element.css('height', 'auto').height(); // Get Auto Height
        element.height(curHeight); // Reset to Default Height
        element.stop().animate({height: autoHeight}, time);
    }

}

function mapStateToProps(state, ownProps) {
    return {
        optionsEmail: state.contactByEmail,
        infoProtectoraDetail: state[ownProps.animalsControlDetail].infoProtectoraDetail,
        infoAnimalDetail: state[ownProps.animalsControlDetail].infoAnimalDetail
    }
}

export default connect(mapStateToProps, {
    init,
    changeNombre,
    changeEmail,
    changeMensaje,
    changeWaitBlock: showWaitBlock
})(Old_CardListingContactByEmail)
